import axios from "axios";

const baseURL = "http://www.international-brands.net";
export const imgBaseURL = "http://oss.chinabrandunion.cn";

export { baseURL };

const request = axios.create({
  baseURL,
  timeout: 10000,
});

request.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.token = token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

request.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export const sendMsg = (phone) => {
  return request({
    url: "/index/login/sendMsg",
    method: "post",
    data: {
      phone,
    },
  });
};

export const register = (phone, password, code) => {
  return request({
    url: "/index/login/regPhoneUsePwd",
    method: "post",
    data: {
      phone,
      password,
      code,
    },
  });
};

export const login = (phone, password) => {
  return request({
    url: "/index/login/loginPhoneByPwd",
    method: "post",
    data: {
      phone,
      password,
    },
  });
};

export const resetPassword = (phone, password, re_password, code) => {
  return request({
    url: "/index/login/resetPassword",
    method: "post",
    data: {
      phone,
      password,
      re_password,
      code,
    },
  });
};

export const getWebSet = () => {
  return request({
    url: "/index/index/webSet",
    method: "get",
  });
};

export const getIndexData = () => {
  return request({
    url: "/index/index/indexData",
    method: "get",
  });
};

export const getNewsList = (classId, page = 1, limit = 20) => {
  return request({
    url: "/index/index/newsList",
    method: "get",
    params: {
      class_id: classId,
      page,
      limit,
    },
  });
};

export const getAboutDetail = (classSonId = "") => {
  return request({
    url: "/index/index/aboutDatail",
    method: "get",
    params: {
      class_son_id: classSonId,
    },
  });
};

export const newsListSearch = (keywords, page = 1, limit = 20) => {
  return request({
    url: "/index/index/newsListSearch",
    method: "get",
    params: {
      keywords,
      page,
      limit,
    },
  });
};

export const newsDetail = (id) => {
  return request({
    url: "/index/index/newsDatail",
    method: "get",
    params: {
      id,
    },
  });
};

export const getTrendDetailHeader = (classId) => {
  return request({
    url: "/index/index/trendDetail",
    method: "get",
    params: {
      class_id: classId,
    },
  });
};

export const newsLike = (newsId) => {
  return request({
    url: "/index/index/newsLike",
    method: "post",
    data: {
      news_id: newsId,
    },
  });
};
